import RoutingBoardView from '@/features/dataflow/routingBoard/RoutingBoard';
import RouteDetailPanel from '@/features/dataflow/routingBoard/RouteDetailPanel';
import { composeRoutingBoard } from '@/features/dataflow/routingBoard/composeRoutingBoard';
import {
  emptyOps,
  emptySystemFlows,
  emptyWorkspaceApis,
  trekkerBrokenOps,
  trekkerHistoryTicks,
  trekkerWorkspaceApis,
  weatherHistoryTicks,
  weatherLiveOps,
  weatherQuietOps,
  weatherSystemFlows,
  weatherWorkspaceApis,
} from '@/features/dataflow/routingBoard/fixtures';

const NOW = new Date('2026-08-25T22:30:00.000Z').getTime();

const live = composeRoutingBoard({
  ops: weatherLiveOps(),
  workspaceApis: weatherWorkspaceApis,
  systemFlows: weatherSystemFlows,
  scopedAppId: 'app_qkzzB',
  now: NOW,
});
const quiet = composeRoutingBoard({
  ops: weatherQuietOps(),
  workspaceApis: weatherWorkspaceApis,
  scopedAppId: 'app_qkzzB',
  now: NOW,
});
const broken = composeRoutingBoard({
  ops: trekkerBrokenOps(),
  workspaceApis: trekkerWorkspaceApis,
  scopedAppId: 'app_g2U0gH20uTC',
  now: new Date('2026-08-23T12:25:46.000Z').getTime(),
});
const empty = composeRoutingBoard({
  ops: emptyOps,
  workspaceApis: emptyWorkspaceApis,
  systemFlows: emptySystemFlows,
  scopedAppId: 'app_liLa8A7VC',
  now: NOW,
});

export default function DataFlowBoardPreview() {
  return (
    <div className="min-h-screen bg-slate-100 p-6 space-y-8">
      <h1 className="text-lg font-semibold text-gray-900">
        Data Flow routing board — fixture proof (not an app seat)
      </h1>

      <section data-testid="preview-live" className="space-y-2">
        <h2 className="text-sm font-medium">1. Live — Weather four feeds</h2>
        <RoutingBoardView model={live} filter="all" now={NOW} />
      </section>

      <section data-testid="preview-quiet" className="space-y-2">
        <h2 className="text-sm font-medium">2. Quiet — enabled Open-Meteo stale</h2>
        <RoutingBoardView model={quiet} filter="quiet" now={NOW} />
      </section>

      <section data-testid="preview-broken" className="space-y-2">
        <h2 className="text-sm font-medium">3. Broken — CNH ssrf_dns_failed</h2>
        <div className="flex gap-4 items-start">
          <div className="flex-1">
            <RoutingBoardView model={broken} filter="all" now={new Date('2026-08-23T12:25:46.000Z').getTime()} />
          </div>
          <RouteDetailPanel
            feed={broken.feeds[0]}
            ticks={trekkerHistoryTicks}
            now={new Date('2026-08-23T12:25:46.000Z').getTime()}
            onClose={() => undefined}
          />
        </div>
      </section>

      <section data-testid="preview-empty" className="space-y-2">
        <h2 className="text-sm font-medium">4. Empty seat — GEO All 0</h2>
        <RoutingBoardView model={empty} filter="all" />
      </section>

      <section className="sr-only">
        {weatherHistoryTicks.map((tick) => tick.ingest_id).join(',')}
      </section>
    </div>
  );
}
